import { render, staticRenderFns } from "./v-preview-input.vue?vue&type=template&id=0bb64141&"
import script from "./v-preview-input.vue?vue&type=script&lang=js&"
export * from "./v-preview-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports